module.exports = __webpack_public_path__ + "static/loading-12b2c248d6f9e99b1a220802345d3106.gif";